import {Col, VertTypography} from '@vertem-core/vertice-ds';
import React from 'react';
import {useNavigate} from "react-router-dom";

const CategoryItems = ({ items, isVoucher }) => {
  const Navigate = useNavigate()
  return items.map((item) => {
    return (
      <Col key={item.supplierId} onClick={() => {
        Navigate(`/search/1/filter/${ encodeURIComponent(btoa(`{"vendors":"${ item.supplierId }"}`)) }`)
      }} xs={12} sm={8} md={8} lg={6} xl={6} spacing="extra-small">
        <div className="ant-card ant-card-bordered vert-card vert-card-product vert-template-marketplace">
          <div className='padding-x-small padding-top-small'>
              <figure className="vert-voucher-picture margin-bottom-small">
                <img
                  src={item.imageUrl}
                  className={'vert-voucher-image'}
                  alt={item.name}
                />
              </figure>
          </div>
          <div className="vert-voucher-body padding-x-small padding-y-small ">
            <VertTypography.Title type={'default'} level={3}>
              <span
                className='color-neutral-dark-darker'
              >
                { item.name }
              </span>
            </VertTypography.Title>
          </div>
        </div>
      </Col>
    );
  });
};

export default CategoryItems;
